import type {ReactElement} from 'react';
import React from 'react';
import {BaseVectorColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-vector-color-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';
import type {TSerializedFabricColor} from '@PosterWhiteboard/items/item/item.types';

interface VectorColorOptionProps {
  onClickColorFill(): void;
}

export function VectorColorOption({...props}: VectorColorOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const fill = useGetKeyFromActiveItem('fill');

  if (!activeItem || (activeItem && !('fill' in activeItem)) || fill === undefined) {
    throw new Error(`Item doesn't have fill property`);
  }

  const onChangeFill = (newFill: TSerializedFabricColor): void => {
    void activeItem.updateFromObject({
      fill: newFill,
    });
  };

  const onClickColorFill = (): void => {
    props.onClickColorFill();
  };

  const updateOpacity = (updatedFillAlpha: number, undoable = true): void => {
    activeItem.updateFillColorOpacity(updatedFillAlpha, undoable);
  };

  return (
    <BaseVectorColorOption
      label={window.i18next.t('pmwjs_fill')}
      fillObject={fill}
      onChangeFill={onChangeFill}
      onClickColorFill={onClickColorFill}
      onChangeOpacity={updateOpacity}
    />
  );
}
